import React, { Component } from "react";
import { observer } from "mobx-react";
import LoginStore from "../../../../stores/LoginStore";
import { buttonCss } from "../../../../stores/LoginStore/Types";

interface Props {
  store: LoginStore;
  loginUser: (e: React.MouseEvent<HTMLElement>) => void;
  onEditEmail: () => void;
}

interface State {
  showPassword: boolean;
}

class LoginForm extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };
  }

  toggleShowPassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  render() {
    const { store, loginUser, onEditEmail } = this.props;
    const { showPassword } = this.state;
    const submitClass = `${buttonCss(store.state.kind)} btn btn-blue signin-submit`;

    return (
      <form noValidate={true} className="signin-form">
        <div className="email-tag">
          <span className="email">{store.email}</span>
          <button type="button" className="edit" onClick={onEditEmail}>
            Edit
          </button>
        </div>
        <div className="field">
          <div className="signin-input has-pwd-toggle">
            <input
              className="password optional fluid input-fields"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              name="session[password]"
              id="session_password"
              autoComplete="off"
              value={store.password}
              onChange={(e) => store.setPassword(e)}
            />
            <button
              type="button"
              className={`pwd-toggle ${showPassword ? "is-shown" : ""}`}
              onClick={this.toggleShowPassword}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? (
                <svg
                  className="icon-hide"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              ) : (
                <svg
                  className="icon-show"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              )}
            </button>
          </div>
          <div className="forgot-row">
            <a id="forgot_password" href="/session/password_resets/new">
              Forgot password?
            </a>
          </div>
          <div className="action">
            <button className={submitClass} onClick={(e) => loginUser(e)}>
              {store.state.kind === "saving" ? "" : "Sign in"}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default observer(LoginForm);
